/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResponseContainerDevicePinResponse } from '../models/ResponseContainerDevicePinResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DevicePinControllerService {
    /**
     * @returns ResponseContainerDevicePinResponse OK
     * @throws ApiError
     */
    public static getPin({
        deviceId,
    }: {
        deviceId: number,
    }): CancelablePromise<ResponseContainerDevicePinResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/care/devices/{deviceId}/pin',
            path: {
                'deviceId': deviceId,
            },
        });
    }
}
